export const RESOLVER_ADDRESS = "0xe9e7FCFBd79dde7d1020D017a6183c05b6C96493"

export const SETTINGS = {
  MIN_VOLUME: 0,
  MAX_VOLUME: 100,
  MAX_TOLL_AMOUNT: 1,
  HARD_MODE_MAX_TOLL_AMOUNT: 0.02,
  TOLL_OPTIONS: [
    {
      label: 'Cub',
      options: [{
        label: '0.001',
        value: 0.001
      }, {
        label: '0.003',
        value: 0.003
      }, {
        label: '0.005',
        value: 0.005
      }]
    },
    {
      label: 'Grizzly',
      options: [{
        label: '0.01',
        value: 0.01
      }, {
        label: '0.03',
        value: 0.03
      }, {
        label: '0.05',
        value: 0.05
      }]
    },
    {
      label: 'Kodiak',
      options: [{
        label: '0.1',
        value: 0.1
      }, {
        label: '0.2',
        value: 0.2
      }, {
        label: 'MAX',
        value: 0.25
      }]
    },
  ]
}

export const SHARE_WORKER_URL = 'https://share.blinko.gg';
